import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { fileService } from '../services/fileService';

export function useFile(id: string | undefined) {
  return useQuery({
    queryKey: ['file', id],
    queryFn: () => fileService.getFile(id!),
    enabled: !!id,
    retry: (failureCount, error) => {
      const status = (error as AxiosError)?.response?.status;
      if (status === 403 || status === 404) return false;
      return failureCount < 1;
    },
  });
}
